module.exports = __webpack_public_path__ + "img/User_friendly_icon.eb0a7343.svg";